import type { SubscriptionEndRefundList } from "@care-by-ella/contracts";
import { API_BASE, apiFetch, withCredentials } from "./api";
import { commonHeaders, jsonOr401 } from "./clinician-api";

// TES-1554 (Ö-863) — "Avslut och återbetalning", admin only. The API logs
// every patient it returns as a read on the support basis; PDL purpose:
// administration.

const BASE = `${API_BASE}/employee-api/v1/subscription-end-refunds`;

export async function fetchSubscriptionEndRefunds(): Promise<SubscriptionEndRefundList> {
  const res = await apiFetch(BASE, {
    headers: { ...commonHeaders(), "X-Access-Purpose": "administration" },
    ...withCredentials,
  });
  return jsonOr401(res);
}
